<script setup lang="ts">
  import { computed } from 'vue'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import CellQC from '@qicgroupdoha/qic-connect-ds/components/CellQC'

  interface Props {
    options?: {
      title: string
      value: string
    }[]
  }

  const props = withDefaults(defineProps<Props>(), {
    options: () => [],
  })

  const filteredOptions = computed(() => props.options?.filter((option) => option.value) ?? [])
</script>

<template>
  <WrapperQC direction="column" class="insured-travelers-options">
    <CellQC
      v-for="(option, idx) in filteredOptions"
      :key="idx"
      :title="option.title"
      :value="option.value"
      padding-block="spacing-2"
    >
      <template #value>
        <div :class="{ ltr: option.title === $t('inbound_travelers_add_mobile_number') }">
          {{ option.value }}
        </div>
      </template>
    </CellQC>
  </WrapperQC>
</template>

<style lang="scss" scoped>
  .insured-travelers-options {
    :deep(.ds-cell__inner) {
      gap: var(--spacing-3);

      .ds-cell__value {
        text-align: end;
      }
    }
  }
</style>
